module.exports = __webpack_public_path__ + "img/4.ef6fd053.jpg";